export default __webpack_public_path__ + "static/media/g-tombraider.a1e73ef4.jpg";